import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

// Get token from cookies each time
export const getCookie = (name: string) => {
  const cookies = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${name}=`));
  return cookies ? cookies.split("=")[1] : null;
};

export const axiosFunction = async (
  url: string,
  method: "GET" | "POST" | "PUT" | "DELETE" | "PATCH",
  body: any = null,
  fileType: boolean = false,
  responseType?:
    | "json"
    | "blob"
    | "text"
    | "document"
    | "arraybuffer"
    | "stream",
  retry = false
): Promise<AxiosResponse<any> | any> => {
  try {
    // ✅ Always get latest token at request time
    const token = getCookie("react-token");

    console.log("Outside recall->>>token", token);

    const config: AxiosRequestConfig = {
      url,
      method,
      headers: {
        Accept: "application/json",
        "Content-Type": fileType ? "multipart/form-data" : "application/json",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        DOMAINNAME: "192.168.149.20",
        Authorization: `Bearer ${token}`,
      },
      data: ["POST", "PUT", "DELETE", "PATCH"].includes(method) ? body : null,
      responseType,
    };

    // For FormData, let axios set the Content-Type with boundary
    if (fileType && body instanceof FormData) {
      delete config.headers!["Content-Type"];
    }

    const response = await axios(config);
    return response;
  } catch (error: any) {
    if (
      (error?.response?.status === 401 || error?.response?.status === 403) &&
      !retry
    ) {
      try {
        // Session API to refresh token
        const res = await axios.get(`${window.location.origin}/session/state`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
            DOMAINNAME: window.location.host,
          },
          withCredentials: true,
        });

        if (res?.status === 200) {
          return axiosFunction(url, method, body, fileType, responseType, true);
        }
      } 
      catch (sessionError) {
        console.error("Session state check failed:", sessionError);
      }
    }

    return error;
  }
};
